<template>
  <div class="document-pager">
    <template v-if="pageNation.count || pageNation.count === 0">
      <button v-if="!pageNation.isFirst" @click="pageNation.clickFirst" class="document-pager-prev">最初へ</button>
      <button v-if="!pageNation.isFirst" @click="pageNation.clickPrev" class="document-pager-prev">前へ</button>
      <ul class="document-pager-list">
        <li
          v-for="page in pageNation.showNumber"
          :key="'page_' + page"
          class="document-pager-item"
          :class="{'is-current': page === pageNation.currentPage}"
          @click="pageNation.clickPage(page)"
          >{{page}}</li>
      </ul>
      <button v-if="!pageNation.isEnd" @click="pageNation.clickNext" class="document-pager-next">次へ</button>
      <button v-if="!pageNation.isEnd" @click="pageNation.clickEnd" class="document-pager-next">最後へ</button>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, isRef, toRefs } from '@vue/composition-api'
import * as logicPagenation from '@/logic/common/Pagenation'

export default defineComponent({
  props: {
    count: {
      type: Number,
      default: 0
    },
    per_page: {
      default: 30
    },
    currentPage: {
      type: Number,
      default: 1
    },
    leftPage: {
      type: Number,
      default: 4
    },
    rightPage: {
      type: Number,
      default: 4
    }
  },
  setup (props, context) {
    // ロジックは既存ページネーションと共通
    const pageNation = logicPagenation.getPagenation(props, context)

    return {
      pageNation
    }
  }
})
</script>
